module.exports = __webpack_public_path__ + "img/billNotice@3x.fc2f5c32.png";